/**
 * useEvidenceDocuments — Fetches rich document metadata for evidence display
 *
 * Given a list of document IDs from a checklist item's linkedDocumentIds,
 * returns enriched document cards with name, date, uploader, and tag info.
 */

import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";
import type { Id } from "@/packages/types";

export interface EvidenceDoc {
  id: Id<"documents">;
  fileName: string;
  uploadedAt: number;
  uploaderName: string;
  tags: { name: string; color: string }[];
  categoryName: string | null;
}

export function useEvidenceDocuments(documentIds: string[]) {
  const ids = documentIds as Id<"documents">[];

  const result = useQuery(
    api.checklist_queries.getDocumentsByIds,
    ids.length > 0 ? { ids } : "skip",
  );

  const isLoading = ids.length > 0 && result === undefined;
  const documents: EvidenceDoc[] = result ?? [];

  return { documents, isLoading };
}
